<template>
    <div>
        <span class="timeline-key">Reason for transfer  </span>: {{extra.reason_for_transfer}}<br>
        <span class="timeline-key">New document type  </span>: {{extra.document_type}}<br>
        <span class="timeline-key">Document number  </span>: {{extra.document_number}}<br>
        <span class="timeline-key">Document validity  </span>: {{extra.document_validity}}<br>
        <span class="timeline-key">Document file </span> :  <file-display :src="extra.document_file"></file-display> <br>
    </div>
</template>

<script>
    import FileDisplay from "../../FileDisplay";

    export default {
        name: "AppliedForVisaTransfer",
        props: ['extra'],
        components: {
            FileDisplay
        }
    }
</script>
